module.exports = __webpack_public_path__ + "static/media/tdg.07a6a4b9.png";